<div [ngClass]="clientItems && clientItems.length > 7 ? 'scroll': ''" >
  <mat-accordion >
    <app-spinner *ngIf="loading"></app-spinner>
    <mat-expansion-panel *ngFor="let device of clientItems" class="acordion ">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <div class="col-8 col-sm-9 col-md-9">
            <h6 class="muted-color">{{ device.SubArea }}</h6>
          </div>

          <div class="col-4 col-sm-3 col-md-3 text-end">
            <div *ngIf="getDataStatus(device.SRNumber).includes('Finalizada')">

              <h6 class="muted-color-4"><span
                  routerLink="tracking/{{device.SRNumber}}/{{getDataStatus(device.SRNumber).split('|')[1]}}"> {{ 'DEVICE.LABEL1' | translate }} </span>
              </h6>
            </div>
            <div *ngIf="getDataStatus(device.SRNumber).includes('En proceso')">
              <h6 class="primary-color"><span
                  routerLink="tracking/{{device.SRNumber}}/{{getDataStatus(device.SRNumber).split('|')[1]}}"> {{ 'DEVICE.LABEL2' | translate }} </span></h6>
            </div>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <app-device-view [device]="device" *ngIf="device && datosGenerales"
        [claimHistory]="getDataHistory(device.SRNumber)" [msspItem]="msspItem"></app-device-view>
    </mat-expansion-panel>
  </mat-accordion>
</div>